import Close from 'src/components/icons/close/Close.vue'
import AnimationProcessing from 'components/animations/processing'
import { Cropper } from "vue-advanced-cropper";
import { ref, watch, onMounted, onUnmounted } from 'vue';
import { MdTypography, MdButton, MdIconClose } from '@antiqua-dls/vue-components'
import "vue-advanced-cropper/dist/style.css";

export default {
    components: {
        Close,
        AnimationProcessing,
        Cropper,
        MdTypography,
        MdButton,
        MdIconClose
    },
    props: {
        image: {
            type: String,
            default: ''
        },
        priority: {
            type: Number,
            default: 0
        },
        fileName:{
            type: String,
            default: 'file.jpg'
        }
    },
    emits: ['set:Image', 'hide:Cropper'],
    setup(props, { emit }) {
        const cropper = ref()
        const imageSrc = ref('')
        const mimeValue = ref('')
        const cropperModalHeader = ref(null)
        const cropperModalBody = ref(null)
        const cropperModalFooter = ref(null)

        const closeCropperModal = (e) => {
            e.preventDefault()
            emit('hide:Cropper')
        }

        const dataURItoBlob = (dataURI) => {
            // convert base64/URLEncoded data component to raw binary data held in a string
            let byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(dataURI.split(',')[1]);
            }

            // separate out the mime component
            let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            mimeValue.value = mimeString

            // write the bytes of the string to a typed array
            let ia = new Uint8Array(byteString.length);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], { type: mimeString });
        }

        const setImage = (e) => {
            e.preventDefault()
            if (cropper.value) {
                const { canvas } = cropper.value.getResult();
                if (canvas) {
                    let fileExtension = imageSrc.value?.split(',')[0]?.split(':')[1]?.split(';')[0];
                    const canvasDataUrl = canvas.toDataURL(fileExtension);
                    const blob = dataURItoBlob(canvasDataUrl);
                    let fileObj = new File([blob], props.fileName, { type: mimeValue.value });
                    emit('set:Image', fileObj)
                }
            }
        }

        const closeModalOutsideClick = (event) => {
            const isCropperModalHeader = cropperModalHeader.value?.contains(event.target)
            const isCropperModalBody = cropperModalBody.value?.contains(event.target)
            const isCropperModalFooter = cropperModalFooter.value?.contains(event.target)
            if (!isCropperModalHeader  && !isCropperModalBody && !isCropperModalFooter) {
                emit('hide:Cropper')
            }
        }

        watch(
            () => props.image,
            (newValue) => {
                imageSrc.value = newValue
            },
            { immediate: true }
        )

        onMounted(() => {
            document.addEventListener('click', closeModalOutsideClick);
        })

        onUnmounted(() => {
            document.removeEventListener('click', closeModalOutsideClick);
        })


        return {
            cropper,
            imageSrc,
            mimeValue,
            cropperModalHeader,
            cropperModalBody,
            cropperModalFooter,
            closeCropperModal,
            closeModalOutsideClick,
            dataURItoBlob,
            setImage
        }

    }
}